<div class="row" *ngIf="pledgeTypesLoaded">
  <div class="col-md">
    <select class="form-select"
            type="text" (change)="setSourcePledgeTypeId($event.target.value)">
      <option value="null">Choose Fund Type</option>
      <option *ngFor="let pledgeType of pledgeTypes" [value]="pledgeType.id">{{pledgeType.name}}</option>
    </select>
  </div>
  <button class="btn btn-outline-primary col-md-2 ms-1" type="submit" (click)="submitMassAssign()">Assign</button>
</div>
